<ptl-v3-content-card [item]="cardItem()" [reserveRows]="reservedRows()" (cardClicked)="onCardOpen()"></ptl-v3-content-card>
